import React from "react";


const Exper = () => {
  return (
    <section className="expert-team">
      <div className="expert-content">
        <h2>
          MEET OUR EXPERT TEAM
        </h2>
        <p>
          Our skilled team combines years of painting expertise with modern
          design innovation, delivering exceptional quality and customer
          satisfaction across every project.
        </p>

        <div className="stats">
          <div className="stat-card blue">
            <h3>25+</h3>
            <p>Skilled Painters</p>
          </div>
          <div className="stat-card green">
            <h3>10+</h3>
            <p>Design Experts</p>
          </div>
          <div className="stat-card red">
            <h3>15+</h3>
            <p>Project Managers</p>
          </div>
        </div>
      </div>

      <div className="expert-image">
        <img src="/assets/images/cotton.webp" alt="Our Expert Team" />
      </div>
    </section>
  );
};

export default Exper;
